import './Skeleton.css';const skeleton = "_skeleton_11bo4_1";
const skeleton__title = "_skeleton__title_11bo4_6";
const skeleton__description = "_skeleton__description_11bo4_28";
const skeleton__back = "_skeleton__back_11bo4_32";
const skeleton__markers = "_skeleton__markers_11bo4_36";
const styles = {
  skeleton,
  skeleton__title,
  skeleton__description,
  skeleton__back,
  skeleton__markers
};
export {
  styles as default,
  skeleton,
  skeleton__back,
  skeleton__description,
  skeleton__markers,
  skeleton__title
};
